import { useTheme } from '@mui/material/styles';
import PropTypes from 'prop-types';
import styled from "@emotion/styled";

const Item = styled.p`
  color: ${({ textColor }) => textColor ? `${textColor} !important` : ''};
	text-decoration: ${({ active, textColor }) => active ? `underline` : 'none'};
  text-underline-offset: 10px;
  // border-bottom: ${({ active, textColor }) => active ? `1px solid ${textColor}` : 'none'};
`;

const Menu = ({ textColor, backgroundColor, backgroundOpacity, menu, sections, ...rest }) => {
  const theme = useTheme();

  // Direct mapping from provided theme:
  const paletteMapping = {
    primary: theme.palette.primary.main, // PRIMARY
    secondary: theme.palette.secondary.main, // SECONDARY
    textPrimary: theme.palette.text.primary, // TEXT
    textSecondary: theme.palette.text.secondary, // LIGHT TEXT
    complementary: theme.palette.background.paper, // COMPLEMENTARY
  };

  const isColorLight = color => {
    if (!color.match(/\d+/g))
      return true
    const [r, g, b] = color.match(/\d+/g).map(Number)
    return (0.299 * r + 0.587 * g + 0.114 * b) / 255 > 0.5
  }

  const headerTextColor = isColorLight(theme.palette.secondary.main)
    ? 'rgb(204, 204, 204)'
    : 'rgb(0, 0, 0)'

  const withOpacity = (color, opacity) => color.replace(/rgba?\(([^)]+)\)/, (_, values) => {
    const [r, g, b] = values.split(',').map(v => v.trim()).slice(0, 3)
    return `rgba(${r}, ${g}, ${b}, ${opacity})`
  })

  return (
    <div
      {...rest}
      style={{
        color: headerTextColor,
				backgroundColor: paletteMapping[backgroundColor]
      }}
    >
      {
        menu.map((item) => {
					if (sections[item.key] === true && item.key != 'footer') {
						return <Item active={item.active} textColor={item.active ? withOpacity(theme.palette.secondary.main, 0.7) : theme.palette.secondary.main}>{item.value}</Item>
					}
        })
      }
    </div>
  );
};

Menu.propTypes = {
  textColor: PropTypes.string,
  backgroundColor: PropTypes.string,
  backgroundOpacity: PropTypes.string,
  children: PropTypes.object,
  sections: PropTypes.object
};

export default Menu;
